import { render, staticRenderFns } from "./ForestTreesBox.vue?vue&type=template&id=70b8c040&scoped=true&"
import script from "./ForestTreesBox.vue?vue&type=script&lang=ts&"
export * from "./ForestTreesBox.vue?vue&type=script&lang=ts&"
import style0 from "./ForestTreesBox.vue?vue&type=style&index=0&id=70b8c040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8c040",
  null
  
)

export default component.exports